import { render, staticRenderFns } from "./BarcodeDiscount.vue?vue&type=template&id=4b1bf6ea&scoped=true"
import script from "./BarcodeDiscount.vue?vue&type=script&lang=js"
export * from "./BarcodeDiscount.vue?vue&type=script&lang=js"
import style0 from "./BarcodeDiscount.vue?vue&type=style&index=0&id=4b1bf6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1bf6ea",
  null
  
)

export default component.exports